import { CountryConfigType } from '../../model/CountryConfigType'

const config: CountryConfigType = {
  showLanguageSelector: true,
}

export default config
